import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=f1d06e5c&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=f1d06e5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1d06e5c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f1d06e5c')) {
      api.createRecord('f1d06e5c', component.options)
    } else {
      api.reload('f1d06e5c', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=f1d06e5c&scoped=true&", function () {
      api.rerender('f1d06e5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2G3tkQTu53nNm/JS/comp/PopupBox.vue"
export default component.exports